import { defaultRoles } from "../../util/workshop.util";
import CountdownTimer from "./countdownTimer";
import Participant from "./participant";

const TaskGroupsStatus = ({ groups, groupTaskStatus, socket, TASK_ID, t, isOnline = false,totalTime=210 }) => {
  return (
    <div className="flex flex-col gap-2 bg-orange-50 rounded-lg border py-2 border-black-100">
      {groups.map((group, index) => (
        <div key={index} className={`relative flex flex-row justify-between p-3 sitems-start`}>
          <Participant id={group.id} name={`Group ${index + 1}`} role={defaultRoles.participant} />
          {groupTaskStatus?.[index]?.finished ? (
            <span className="rounded-full p-4 bg-green-300 text-green-100 w-fit">
              {t("task.ready")}
            </span>
          ) : (
            <CountdownTimer
              id={`${TASK_ID}-${index}`}
              start={groupTaskStatus?.[index]?.started}
              totalTime={totalTime}
              trailColor={isOnline ? "#fff" : undefined}
              textColor={isOnline ? "#E59536" : undefined}
              strokeWidth={isOnline ? 5 : undefined}
              size={isOnline ? 60 : undefined}
              orangeClock={isOnline}
              finished={groupTaskStatus?.[index]?.finished}
              onReset={() => {
                socket.emit("updateGroupTaskStatus", {
                  taskId: TASK_ID,
                  groupId: index,
                  started: true,
                  ready: true,
                  finished: false,
                  remainingTime: totalTime,
                  timerId: `${TASK_ID}-${index}`
                });
              }}
              greyedOnCompletion
              customClass={`absolute right-0 ${group?.length === 2 ? "top-[55%]" : "top-1/2"} -translate-y-1/2 -translate-x-1/4`}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default TaskGroupsStatus;
